import { useRef } from 'react';
import React from 'react'
import SetMulFun from '../Function/SetMulFun';
import { useState } from 'react'

const random = (min, max) => {
    return (Math.floor(Math.random()
        * (max - min + 1)) + min);
}
const SetMul = () => {
    // const [dicrange, setdicrange] = React.useState(1000);
    const getswitch = (digit1) => {

        switch (digit1) {
            case '1':
                return random(2, 9)
                break;
            case '2':
                return random(10, 99)
                break;
            case '3':
                return random(100, 999)
                break;
            case '4':
                return random(1000, 9999)
                break;
            default:
                break;
        }
    }
    const [dicrange, setdicrange] = React.useState();
    const [dic, setdic] = React.useState(0);
    const [digit1, setdigit1] = React.useState();
    const [digit2, setdigit2] = React.useState();
    const [ques, setques] = React.useState();
    const [file, setfile] = React.useState();
    const [setspeed, setsetspeed] = React.useState("");
    const [Particular, setParticular] = React.useState(0);
    const [ParticularNumber, setParticularNumber] = React.useState(0);
    const [down, setdown] = React.useState(0);
    const [btn, setbtn] = React.useState(0);
    // const mat = []
    const [mat, setmat] = useState([])
    const [refrsh, setrefrsh] = useState(0)
    let lowval = 1;

    const refpdf = useRef();

    const getmat = (ques, digit1, digit2) => {
        let temp = []
        let ele1;
        let ele2;
        for (let j = 0; j < ques; j++) {
            if (ParticularNumber) {
                ele1 = ParticularNumber;
            } else {
                ele1 = getswitch(digit1)
            }
            temp.push(ele1)

            ele2 = getswitch(digit2)
            temp.push(ele2)
            mat.push(temp)
            temp = []
        }
    }


    function cal(event) {
        event.preventDefault();
        if (refrsh) {
            window.location.reload()
        }
        getmat(ques, digit1, digit2)
        console.log(mat)
        let min;
        let max;

        switch (digit1) {
            case '1':
                min = 1
                max = 9
                break;
            case '2':
                min = 10
                max = 99
                break;
            case '3':
                min = 100
                max = 999
                break;
            case '4':
                min = 1000
                max = 9999
                break;
            default:
                break;
        }
        if (mat.length != 0) {
            let row = 2;
            setbtn(1)
            setsetspeed("set")
        }

    }

    let props = {
        // ques:ques,
        mat: mat,
        file: file,
        dicrange: dicrange,
        setspeed: setspeed
    }

    const targetRef = useRef();

    return (
    <div className='bg'>

      <div className='main'>
        <form onSubmit={cal} className='main-form'>
          {/* <h2 className='form-name'>Multiplication</h2> */}
          <h2 className='form-name'><span className='underline'>Multiplication</span> (Set)</h2>

          <label htmlFor="digit">Number of Digit X Digit</label>
          <div className='mul_dig'>
            <input type="number" max="4" name="name" className='box input-fld' id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />
            <h3>X</h3>
            <input type="number" max="4" name="email" id="row" placeholder="3" className='box input-fld' required onChange={(e) => { setdigit2(e.target.value) }} />
          </div>
          {/* <div className='check'>
            <label htmlFor="zig">Select A Particular Number  -- </label>
            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return Particular? setParticular(false) : setParticular(true) }} />
            {Particular?<input type="number" name="particular" className='input-fld' id="particular"  onChange={(e)=>{setParticularNumber(e.target.value)}} />:""}
          </div> */}
          <div className='check check-dic'>
            <label htmlFor="dictation">dictation? -- </label>
            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return dic ? setdic(false) : setdic(true) }} />
            <div className={dic ? "show-range" : "hide-range"}>
            <div className='set-dic'>
                {/* <input type="range" id="vol" name="vol" min=".7" value={dicrange} step=".10" onChange={() => { setdicrange(document.getElementById("vol").value) }} max="2.0" />
                <p>{dicrange ? dicrange : "1"}</p> */}
                  <div>
                    <input type="radio" id="html" name="fav_language" onClick={() => { setdicrange(.7) }} />
                    <label id='slow'>Slow</label><br />
                  </div>
                  <div>
                    <input type="radio" id="css" name="fav_language" value="CSS" onClick={() => { setdicrange(1) }} />
                    <label id='Medium'>Medium</label><br />
                  </div>
                  <div>
                    <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(1.3) }} />
                    <label id='Fast'>Fast</label>
                  </div>
                  <div>
                    <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(1.6) }} />
                    <label id='Super_Fast'>Super Fast</label>
                  </div>
              </div>

            </div>
          </div>
          <label htmlFor='ques'>No Of Questions</label>
          <input type="number" name="ques" id="ques" className='box' placeholder="10" max={100} required onChange={(e) => { setques(e.target.value) }} />
          <label htmlFor='ques'>File name</label>
          <input type="text" name="file" id="file" className='box' placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />
          <div className='submit'>
            <input type="submit" id='reset' className='bt-purple' value="Finish" />
            <input type="reset" id='reset' className='bt-purple' value="Refresh" onClick={() => { window.location.reload() }} />
          </div>
        </form>
      </div>
      <div className={btn ? "show-FlashFun" : "hide-FLashFun"}>
        <div className={btn ? "flash-pop-bg" : "flash-no-pop-bg"}></div>
        <div className={btn ? "flash-pop-up" : "flash-no-pop-up"}>
          <button className='X-btn' onClick={() => { setbtn(0) }}>X</button>
          <SetMulFun  {...{ mat, ques, file, dicrange, dic ,setspeed}} />

        </div>
      </div>
    </div>

    )
}
export default SetMul